import React from 'react';
import styled, { StyledComponentClass } from 'styled-components';

import { colors, globals } from '../../styles';
import { PillsSelectProps } from './props';

import classnames from 'classnames';

export interface QuestionOptions {
  name: string;
  value: string;
  description?: string;
}

const grey = '#d8dade';

export class SelectPills extends React.Component<PillsSelectProps, any> {
  constructor(props) {
    super(props);

    this.state = {
      selectedValues: this.props.selected || [],
    };
  }

  componentWillReceiveProps(newProps) {
    this.setState({ selectedValues: newProps.selected || [] });
  }

  handleChange(item) {
    if (this.props.disabled) {
      return;
    }

    let items = this.state.selectedValues;

    if (this.props.multiple) {
      const index = items.indexOf(item.value);

      if (index === -1) {
        items.push(item.value);
      } else {
        items.splice(index, 1);
      }
    } else {
      if (items[0] && items[0] === item.value) {
        items = [];
      } else {
        items = [item.value];
      }
    }

    this.setState({
      selectedValues: items,
    });

    this.props.onChange(items);
  }

  componentWillUnmount() {
    if (this.props.onComponentUnmount !== undefined) {
      this.props.onComponentUnmount(this.state.selectedValues);
    }
  }

  isSelected(value: string) {
    if (this.props.multiple) {
      return this.state.selectedValues.indexOf(value) > -1;
    } else {
      if (typeof this.state.selectedValues === 'string') {
        return this.state.selectedValues === value;
      } else {
        return this.state.selectedValues[0] === value;
      }
    }
  }

  getDominantColor = () => {
    return this.props.color ? this.props.color : grey;
  };

  render() {
    const { className, disabled, options, multiple } = this.props;
    const theme = {
      dominant: this.getDominantColor(),
    };

    return (
      <StyledSelectPills
        className={`${multiple ? 'multiple' : ''}`}
        theme={theme}
      >
        {options.map((item, i) => (
          <button
            key={i}
            className={classnames({
              [className]: true,
              disabled,
              selected: this.isSelected(item.value),
            })}
            onClick={this.propagateClick(item)}
            data-title={item.description}
            data-accesskey={item.accesskey}
          >
            {item.name}
          </button>
        ))}
      </StyledSelectPills>
    );
  }

  private propagateClick(
    item: QuestionOptions,
  ): (event: React.MouseEvent<HTMLButtonElement>) => void {
    return e => this.handleChange(item);
  }
}

const StyledSelectPills = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
  align-content: stretch;
  border-radius: ${globals.borderRadiusValue};
  border: 1px solid ${grey};
  border-bottom: 0;
  border-right: 0;
  background: ${grey};

  &.multiple {
    background: transparent;
    padding: 0;
    border: 0;
    border-radius: 0;

    button {
      border: 1px solid ${grey};
      margin-right: 1em;
      margin-bottom: 1em;
      border-radius: ${globals.borderRadiusValue} !important;
    }
  }

  button {
    ${globals.button};

    border-radius: 0;
    background: white;
    color: ${colors.grey900};
    transition: 100ms linear background;
    flex-grow: 1;
    margin: 0 1px 1px 0;
    position: relative;
    top: 0;

    &.disabled {
      background: #edeeef;
      box-shadow: 0 0 1px ${colors.grey300};
      color: ${colors.grey300};
      cursor: default;
    }

    &.selected {
      background: ${props => props.theme.dominant};
      color: white;
      position: relative;
      top: 0;

      &:after {
        position: absolute;
        top: 0;
        left: 0;
        display: block;
        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, 0);
        content: '';
        transition: 300ms linear all;
      }

      &:hover {
        background: ${props => props.theme.dominant};

        &:after {
          background: rgba(255, 255, 255, 0.4);
        }
      }
    }

    :hover {
      background: ${props => props.theme.dominant};
      color: #fff;
    }
  }
`;

export default SelectPills;
